/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'

import colors from '../../../../../assets/colors'
import {
  showNfseConfig,
  storeNfseConfig,
  indexNfseEnquadramento,
  storeNfseEnquadramento,
  updateNfseEnquadramento,
  destroyNfseEnquadramento,
} from '../../../LaundryEletronicInvoiceActions'
import { SNACKBAR } from '../../../../main/MainActions'
import Enquadramentos from '../Enquadramentos'
import { NFSE_ENQUADRAMENTO_FIELDS } from '../Enquadramentos/fields'

const useStyles = makeStyles({
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  btnSave: {
    borderRadius: '20px',
    color: '#FFF',
    backgroundColor: colors.primary,
    fontSize: '12px',
    textTransform: 'capitalize',
    width: '101px',
    padding: '4px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: '.7',
    },
  },
})

const NfseConfig = ({
  active = false,
  handleChangeEletronicInvoiceNational = active => {},
}) => {
  const dispatch = useDispatch()

  const classes = useStyles()

  const [form, setForm] = useState({
    regime_especial_tributacao: '',
    optante_simples_nacional: '',
  })

  const fetchNfseConfig = async () => {
    try {
      const resp = await showNfseConfig()

      if (resp?.data) {
        setForm({
          ...form,
          ...resp?.data,
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const data = new FormData(e.target)

    try {
      const resp = await storeNfseConfig(data)

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'Sucesso!' },
      })
    } catch (e) {
      console.log(e)

      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Erro ao atualizar configurações!' },
      })
    }
  }

  useEffect(() => {
    fetchNfseConfig()
  }, [])

  return (
    <Grid container xs={12}>
      <Grid item xs={12} className={classes.box}>
        <Box className={classes.subTitle}>Emissor municipal de NFse.</Box>

        <form onSubmit={handleSubmit} hidden={!active}>
          <Grid container spacing={4}>
            <Grid item md={4} xs={6}>
              <TextField
                select
                name="regime_especial_tributacao"
                fullWidth
                label="Regime Especial de Tributação"
                required
                defaultValue={form?.regime_especial_tributacao}
                key={form?.regime_especial_tributacao}
              >
                <MenuItem value="">Selecione...</MenuItem>
                <MenuItem value="1">Microempresa municipal</MenuItem>
                <MenuItem value="2">Estimativa</MenuItem>
                <MenuItem value="3">Sociedade de profissionais</MenuItem>
                <MenuItem value="4">Cooperativa</MenuItem>
                <MenuItem value="5">MEI - Simples Nacional</MenuItem>
                <MenuItem value="6">ME EPP - Simples Nacional</MenuItem>
              </TextField>
            </Grid>

            <Grid item md={5} xs={6}>
              <TextField
                select
                name="optante_simples_nacional"
                fullWidth
                label="Optante pelo simples Nacional"
                required
                defaultValue={form?.optante_simples_nacional}
                key={form?.optante_simples_nacional}
              >
                <MenuItem value="">Selecione...</MenuItem>
                <MenuItem value="1">Sim</MenuItem>
                <MenuItem value="0">Não</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs>
              <Grid
                container
                justifyContent="flex-end"
                alignItems="flex-end"
                style={{ height: '100%' }}
              >
                <Grid item>
                  <Button type="submit" className={classes.btnSave}>
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>

        <Enquadramentos
          title="Enquadramentos tributários (Municipal)"
          fields={NFSE_ENQUADRAMENTO_FIELDS}
          indexFn={indexNfseEnquadramento}
          storeFn={storeNfseEnquadramento}
          updateFn={updateNfseEnquadramento}
          destroyFn={destroyNfseEnquadramento}
        />
      </Grid>
    </Grid>
  )
}

export default NfseConfig
